import { CheckIcon } from './CheckIcon';

/**
 * author: Google
 * id F789CE44-7EA3-4E97-88FB-BEC22EB2030C
 * name check
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/check.svg
 * tags
 * - Form 
 */
export const TickIcon = CheckIcon;
export default TickIcon